import React, { useEffect, useRef, useState } from "react";
import NestedTable from "../../components/NestedTable/NestedTable";
import "./AllProposals.css";
import Pagination from "../../components/Pagination/Pagination";
import PopUp from "../../components/PopUp/PopUp";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
//import { Globals } from "../../global/Globals";
import { fetchByfilter, fetchChannelbyClusters } from "../../services/GenericAPI";
import {
  fetch_All_Proposals,
  fetch_All_SM_Proposals,
  fetch_All_SM_Unsolicited_Proposals,
  fetch_All_Unsolicited_Proposals,
  fetchFilterByCreatedBy,
  fetchFilterByProducer,
  fetchFilterByProducerByType,
  fetchFilterProposalStatus,
  fetchFilterProposalStatusUnsolicited,
  fetchGenrebyCluster,
  fetchGenresAllproposals,
  reAssingBriefSubmit,

} from "../../services/dashboardAPI";
import Search from "../../components/SearchBar/Search";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { setAllRejectionReasons } from "../../pages/SignUp/ProducerRegistrationSlice";
import Toast from "../../components/Toast/Toast";
import { fetchAllProposalRejectionReasons, hopEvaluationProposalSubmit, rejectUnsolicatedProposal, smEvaluationProposalSubmit, unSolicatedProposalUpdate, updateFavourite } from "../../services/api";
import { useCluster } from "../../pages/ClusterContext/ClusterContext";
import { useNavigate, useLocation } from "react-router-dom";
import CryptoUtils from "../../util/cryptoUtils";
import { useRole } from "../../context/Rolecontext";
import ToggleSwitchButton from "../../components/ToggleSwitchButton/ToggleSwitchButton";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

let paginationPageChange = () => { };
const AllProposals = () => {
  const [favToggleState, favState] = useState(false);
  const { Globals, languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const currentTab = location?.state?.selectedTab;
  const { success, draft, discard, toastValue, errorToastValue, isCEReviewdraft } = location.state || {};
  const [proposalsData, setproposalsData] = useState(null);
  const [propsalsCount, setProposalsCount] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const selectedBriefno = useSelector(state => state.login.selectedTableItem);
  const [searchQuery, setSearchQuery] = useState(selectedBriefno || null);
  const [searchProducerQuery, setSearchProducerQuery] = useState(null);
  const [activeTab, setActiveTab] = useState(OldGlobals.AllPROPOSALS.SOLICITED);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [roleID, setroldId] = useState(CryptoUtils.getFromLocalStorage("roleId")?.toString());
  const [dataSorting, setDatasorting] = useState(1);
  const [proposalsDatastatus, setproposalsDatastatus] = useState(null);
  const [Popup, setPopup] = useState({ isNewAcceptanceMail: false, newRejection: false, open: false, title: '', promptText: '', customClassName: '', normalActionText: '', textAreaTitle: '', textAreaStyle: '', toastMessage: '', body: '' });
  const [reasonPopup, setReasonPopup] = useState({ open: false, title: '', promptText: '', customClassName: '', normalActionText: '', textAreaTitle: '', textAreaStyle: '', toastMessage: '', body: '' });
  const [toast, setToast] = useState({ open: false, status: '', title: "" });
  const [smEvaluation, setSmEvaluation] = useState('')
  const [hopEvaluation,setHOPEvaluation] =useState('')
  const allRejectionReasonsData = useSelector(state => state.producerRegistration.allRejectionReasons);
  const [successToast, setSuccessToast] = useState({ status: false, title: Globals.PROPOSAL_SUBMIT_SUCCESS });
  const [clusterId, setClusterId] = useState();
  const [clusterName, setClusterName] = useState();
  const prevSelectedState = useRef({});
  const isInitialRenderPage = useRef(true);
  const isInitialRenderSort = useRef(true);
  const isInitialRenderDropdown = useRef(true);
  const isInitialRenderSearch = useRef(true);
  const isIntialRenderRole = useRef(true);
  const isIntialRenderLanguage = useRef(true);
  const isInitialRenderToggle = useRef(true);
  const dropdownRefs = useRef({}); // Store refs for dropdowns
  const { selectedClusters } = useCluster();
  const { selectedRole } = useRole();
  const [pageSelected, setPageSelected]=useState();
  const checkReAssign = Popup.title === Globals.HALF_PAGE_BRIEF_DETAILS.RE_ASSIGN_PROPOSAL;
  const selectedPage=location?.state?.page?location?.state?.page:1;
  const [searchTrigger, setSearchTrigger] = useState(0);
  localStorage.removeItem('isDraft'); 
  const [favUnfavloading,setFavUnfavloading] = useState(null);
  useEffect(() => {
    if (currentTab === 'solicited') {
      setActiveTab(OldGlobals.AllPROPOSALS.SOLICITED)
      setPageSelected(selectedPage);
    } else if (currentTab === 'unSolicited') {
      setActiveTab(OldGlobals.AllPROPOSALS.UNSOLICITED)
      setPageSelected(selectedPage);
    }
  }, [currentTab]);

  useEffect(() => {
    if (toastValue) {
      renderToast('success', toastValue)
    }
  }, [toastValue])

useEffect(()=>{
  if (isInitialRenderToggle.current) {
      isInitialRenderToggle.current = false;
      return; // Skip on first render
    }
  if(favToggleState) {
    refreshDashboard();
  } else {
    favState(false);
    refreshDashboard();
  }
},[favToggleState])

  useEffect(() => {
    if (errorToastValue) {
      renderToast('error', errorToastValue)
    }
  }, [errorToastValue])

  useEffect(() => {
    if (success) {
      if (draft) {
        setSuccessToast({ status: true, title: Globals.PROPOSAL_SAVE_SUCCESS });
      } else if (discard) {
        // setSuccessToast({status:true,title:Globals.TOAST_DISCARD_PROPOSAL_PROMPT_TITLE});
      }
      else {
        setSuccessToast({ status: true, title: Globals.PROPOSAL_SUBMIT_SUCCESS });
      }
      setTimeout(() => {
        setSuccessToast({ status: false, title: "" });
      }, 4000);
    }
  }, [success]);
    useEffect(() => {
      if (success) {
        if(draft){
          setSuccessToast({status:true,title:Globals.PROPOSAL_SAVE_SUCCESS});
        }else if(discard){
          // setSuccessToast({status:true,title:Globals.TOAST_DISCARD_PROPOSAL_PROMPT_TITLE});
        }
        else{
          setSuccessToast({status:true,title:Globals.PROPOSAL_SUBMIT_SUCCESS});
        }
        setTimeout(() => {
          setSuccessToast({status:false,title:""});
        }, 4000);
      }
    }, [success]);

  /**This useEffect is to show CE Evaluation successfully drafted toast message */
  useEffect(() => {
    if (isCEReviewdraft) {
      setSuccessToast({ status: true, title: Globals.CE_EVAL_SAVE_AS_DRAFT_TOAST_SUCCESS_MSG });
    }
  }, [isCEReviewdraft])

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      CHANNEL: { options: [], selected: [], selectedText: [], isloading: false },
      CREATEDBY: { options: [], selected: [], selectedText: [], isloading: false },
      PRODUCER: { options: [], selected: [], selectedText: [], isloading: false },
      GENRE:{ options: [], selected: [], selectedText: [], isloading: false },
      DATE: {
        selected: [],
        selectedMonthYear: [],
        selectedText: [],
        isDatePicker: true,
        isloading: false,
      },
      STATUS: { options: [], selected: [], selectedText: [], isloading: false },
    },
  });
  const [isClearAllTriggered, setIsClearAllTriggered] = useState(false);

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsDrawerOpen(true);
  };
  const handlePopupClose = () => {
    setSelectedItem(null);
  };

  //Functionality for the OnPageChange
  const onPageChange = (pageNumber, setPage = () => { }) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  //Functionality for the TabChange
  const handleTabClick = (tab) => {
    setproposalsDatastatus(null);
    setproposalsData(null);
    setProposalsCount(null);
    handleClearAll();
favState(false);
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    setActiveTab(tab);
    const data = {
      ...(tab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : tab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected
          }
          : {}), // Ensure an empty object if neither condition matches

      [tab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      genre:dropdownState.dropdowns.GENRE.selected,
      status: dropdownState.dropdowns.STATUS.selected,
      search: searchQuery ? searchQuery : "",

      filter: dataSorting,
      clusterId: clusterId,
      isFavourite: favToggleState,
    };
    fetchOptions((OldGlobals.FILTER.PRODUCER).toUpperCase(), tab);
    paginationPageChange(1);
    fetchAllProposals(data, 1, tab);
  };

  const openPopup = (data) => {
    setPopup(data)
  }
  const closePopup = () => {
    setPopup({ open: false })
  }
  const openReasonPopup = (data) => {
    setReasonPopup(data)
  }
  const closeReasonPopup = () => {
    setReasonPopup({ open: false })
  }
  const toggleSmEvaluation = (data) => {
    setSmEvaluation({ open: true, ...data })
  }

const toggleHOPEvaluation=(data)=>{
  setHOPEvaluation({open:true,...data})
}

  const renderToast = (status, title) => {
    setToast({ open: true, status: status, title: title });
    setTimeout(() => {
      setToast({ open: false, status: '', title: '' });
      //below code is to remove recurring retained toast message
      const newState = { ...location.state };
      delete newState.toastValue;
      delete newState.errorToastValue;
      navigate(location.pathname, { replace: true, state: newState });
    }, 4000);
  }

  const handleAfterUnfavourite = (newTotalCount) => {
  // items per page
  const pageSize = 20;

  // calculate maximum available page
  const maxPage = Math.ceil(newTotalCount / pageSize);

  if (currentPage > maxPage) {
    setCurrentPage(maxPage > 0 ? maxPage : 1); // fallback to page 1 if nothing left
    return maxPage > 0 ? maxPage : 1;
  }
  return currentPage;
};

  const refreshDashboardfavtoggle = (newTotalCount) => {
  setproposalsDatastatus(null);
  setproposalsData(null);
  setProposalsCount(null);

  const validPage = handleAfterUnfavourite(newTotalCount);

  const data = {
    ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
      ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length
            ? dropdownState.dropdowns.PRODUCER.selected[0]
            : "string",
        }
      : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
      ? {
          producer: dropdownState.dropdowns.PRODUCER.selected,
          channel: dropdownState.dropdowns.CHANNEL.selected,
        }
      : {}),

    [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
      dropdownState.dropdowns.DATE.selected.length > 0
        ? dropdownState.dropdowns.DATE.selected
        : "string",

    ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
      ? { status: dropdownState.dropdowns.STATUS.selected }
      : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
      ? { proposalStatus: dropdownState.dropdowns.STATUS.selected }
      : {}),

    genre: dropdownState.dropdowns.GENRE.selected,
    search: searchQuery ? searchQuery : "",
    filter: dataSorting,
    clusterId: clusterId,
    isFavourite: favToggleState,
  };

  fetchAllProposals(data, validPage, activeTab);
};

  const refreshDashboard = () => {
    setproposalsDatastatus(null);
      setproposalsData(null);
      setProposalsCount(null);
      setproposalsDatastatus(null);
  setproposalsData(null);
  setProposalsCount(null);
  console.log("favtogglestate",favToggleState);

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
          }
          : {}),

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),
    genre:dropdownState.dropdowns.GENRE.selected,
    search: searchQuery ? searchQuery : "",
    filter: dataSorting,
    clusterId: clusterId,
    isFavourite: favToggleState,
  };
  if(favToggleState){
    paginationPageChange(1);
    fetchAllProposals(data, 1, activeTab);
  }else{
  fetchAllProposals(data, currentPage, activeTab);
  }
}

  useEffect(() => {
    if (isIntialRenderRole.current) {
      isIntialRenderRole.current = false;
      return; // Skip on first render
    }
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [], selected: [], selectedText: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
          }
          : {}),

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),
       genre:dropdownState.dropdowns.GENRE.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId: clusterId,
    isFavourite: favToggleState,
    };
    fetchAllProposals(data, 1, activeTab);
    fetchOptions((OldGlobals.FILTER.PRODUCER).toUpperCase(), activeTab);
  }, [roleID]);

  const unsolicatedProposalStatus = (body, toastMessage) => {
    if (Popup?.newRejection) {
      body['rejectionReasonId'] = CryptoUtils.getFromLocalStorage("reasonId") || '';
    }
    if (Popup.isReject) {
      rejectUnsolicatedProposal(body)
        .then((response) => {
          if (response.data.status === "OK") {
            renderToast("success", toastMessage)
            refreshDashboard()
          } else {
            renderToast("error", Globals.TOAST_FAILURE);
          }
        })
        .catch((error) => {
          renderToast("error", Globals.TOAST_FAILURE)
          console.error(error);
        });
    }
    else if (smEvaluation.isSmEvaluation) {
      smEvaluationProposalSubmit(body)
        .then((response) => {
          if (response.data.status === "OK") {
            renderToast("success", toastMessage)
            refreshDashboard()
          } else {
            renderToast("error", Globals.TOAST_FAILURE);
          }
        })
        .catch((error) => {
          renderToast("error", Globals.TOAST_FAILURE)
  console.error(error);
});
  }
  else if (hopEvaluation.isHOPEvaluation) {
    console.log("hop Eval body", body);
    hopEvaluationProposalSubmit(body)
      .then((response) => {
        if (response.data.status === "OK") {
          renderToast("success", toastMessage)
          refreshDashboard()
        } else {
          renderToast("error", Globals.TOAST_FAILURE);
        }
      })
      .catch((error) => {
        renderToast("error", Globals.TOAST_FAILURE)
                console.error(error);
              });
    }
    else {
      unSolicatedProposalUpdate(body)
        .then((response) => {
          if (response.data.status === "OK") {
            renderToast("success", toastMessage)
            refreshDashboard()
          } else {
            renderToast("error", Globals.TOAST_FAILURE);
          }
        })
        .catch((error) => {
          renderToast("error", Globals.TOAST_FAILURE)
          console.error(error);
        });
    }

  }

  const reassignProposal = (body, toastMessage) => {
    const reAssignProposalRequestBody = {
      "proposalId": body?.proposalId,
      "proposalDetailId": body?.proposalDetailId,
      "status": 4,
      "comment": body?.comment,
      "clusterId": body?.clusterId,
      "channelId": body?.channelId,
    }
    reAssingBriefSubmit(reAssignProposalRequestBody)
      .then((response) => {
        if (response.data.status === "OK") {
          renderToast("success", toastMessage)
          refreshDashboard()
        } else {
          renderToast("error", Globals.TOAST_FAILURE);
        }
      }).catch((error) => {
        renderToast("error", Globals.TOAST_FAILURE)
      });
  }

  useEffect(() => {
    if (searchQuery !== null) {
      setEnableClearAll(true);
    }
    if (clusterId && clusterName) {
      const data = {
        ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
          ? {
            channel: dropdownState.dropdowns.CHANNEL.selected,
            createdBy: dropdownState.dropdowns.CREATEDBY.selected,
            producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
          }
          : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
            ? {
              producer: dropdownState.dropdowns.PRODUCER.selected,
            }
            : {}),

        [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
          dropdownState.dropdowns.DATE.selected.length > 0
            ? dropdownState.dropdowns.DATE.selected
            : "string",
        ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
          ? {
            status: dropdownState.dropdowns.STATUS.selected,
          }
          : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
            ? {
              proposalStatus: dropdownState.dropdowns.STATUS.selected,
            }
            : {}),
        genre:dropdownState.dropdowns.GENRE.selected,
        search: searchQuery ? searchQuery : "",
        filter: dataSorting,
        clusterId: clusterId,
        channel: dropdownState.dropdowns.CHANNEL.selected,
          isFavourite: favToggleState,
      };
      paginationPageChange(1);
      fetchAllProposals(data, 1, activeTab);
      fetchOptions((OldGlobals.FILTER.PRODUCER).toUpperCase(), activeTab);
    }

  }, [clusterId, clusterName]);

  useEffect(() => {
    const initialCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    if (initialCluster?.length > 0) {
      setClusterId(initialCluster[0].clusterId);
      setClusterName(initialCluster[0].clusterName);
    }
  }, []);

  //cluster Change logic
  useEffect(() => {

    const newCluster = JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"));
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    if (newCluster) {
      setClusterId(newCluster[0].clusterId);
      setClusterName(newCluster[0].clusterName);
    }
  }, [selectedClusters]);

  //Role Change logic
  useEffect(() => {
    if (clusterId) {
      setroldId(CryptoUtils.getFromLocalStorage("roleId")?.toString());
    }
  }, [selectedRole]);

  // Functionality for DropDownchange
  useEffect(() => {
    if (isInitialRenderDropdown.current) {
      isInitialRenderDropdown.current = false;
      prevSelectedState.current = Object.fromEntries(
        Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
      );
      return;
    }

    let hasSelectedChanged = false;

    for (const key of Object.keys(dropdownState.dropdowns)) {
      const currentSelected = dropdownState.dropdowns[key]?.selected || [];
      const prevSelected = prevSelectedState.current[key] || [];

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasSelectedChanged = true;
        break;
      }
    }

    if (!hasSelectedChanged && !isClearAllTriggered) return;

    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected?.length > 0
    );

    setEnableClearAll(hasSelectedOptions || !!searchQuery);

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
          }
          : {}),

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",

      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? { proposalStatus: dropdownState.dropdowns.STATUS.selected }
          : {}),
      genre:dropdownState.dropdowns.GENRE.selected,
      search: searchQuery || "",
      filter: dataSorting,
      clusterId: clusterId,
      channel: dropdownState.dropdowns.CHANNEL.selected,
      isFavourite: favToggleState,
    };

    paginationPageChange(1);
    fetchAllProposals(data, 1, activeTab);

    // Update only selected values in ref
    prevSelectedState.current = Object.fromEntries(
      Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
    );

    if (isClearAllTriggered) setIsClearAllTriggered(false);
  }, [dropdownState, isClearAllTriggered]);


  // Functionality for PageChange
  useEffect(() => {
    if (isInitialRenderPage.current) {
      isInitialRenderPage.current = false;
      return; // Skip on first render
    }
    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected
          }
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),
      genre:dropdownState.dropdowns.GENRE.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId: clusterId,
      isFavourite: favToggleState,
    };
    fetchAllProposals(data, currentPage, activeTab);
  }, [currentPage]);

  // Functionality for SearchChange
  useEffect(() => {
    if (isInitialRenderSearch.current) {
      isInitialRenderSearch.current = false;
      return; // Skip on first render
    }
    setproposalsDatastatus(null);
      setproposalsData(null);
      setProposalsCount(null);

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
          }
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),
      genre:dropdownState.dropdowns.GENRE.selected,
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      channel: dropdownState.dropdowns.CHANNEL.selected,
      clusterId: clusterId,
      isFavourite: favToggleState,
    };
    paginationPageChange(1);
    fetchAllProposals(data, 1, activeTab);
  }, [searchQuery,searchTrigger]);

  // Functionality for sorting
  useEffect(() => {
    if (isInitialRenderSort.current) {
      isInitialRenderSort.current = false;
      return; // Skip on first render
    }
    setproposalsDatastatus(null);
    setproposalsData(null);
    setProposalsCount(null);

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,

        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            channel: dropdownState.dropdowns.CHANNEL.selected,
            createdBy: dropdownState.dropdowns.CREATEDBY.selected,

          }
        : activeTab === Globals.AllPROPOSALS.UNSOLICITED
        ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
          }
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected
          }
          : {}),

      ...(activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED && ( roleID === Globals.USER_ROLES.SNR_MGR || roleID === Globals.USER_ROLES.HOP)
        ? {
          producerOrTitleSearch: searchProducerQuery || "",
          propRefNoSearch: searchQuery || "",
        }
        : {
          search: searchQuery ? searchQuery : "",
        }),
      genre:dropdownState.dropdowns.GENRE.selected,
      filter: dataSorting,
      clusterId: clusterId,
      isFavourite: favToggleState,
    };
    fetchAllProposals(data, currentPage, activeTab);
  }, [dataSorting]);

  //Api calling for the Soliticed and Unsolicited Proposals
  async function fetchAllProposals(filters, pagenumber, activetab) {
    try {
      let responseData;
      if (activetab === OldGlobals.AllPROPOSALS.SOLICITED && (roleID !== OldGlobals.USER_ROLES.SNR_MGR && roleID !== OldGlobals.USER_ROLES.HOP)) {
        responseData = await fetch_All_Proposals(filters, pagenumber, roleID);
        setproposalsData(responseData?.data?.content?.briefs);
        setProposalsCount(responseData?.data?.content?.pageCount);
        setproposalsDatastatus(responseData.data.status);
        setFavUnfavloading(responseData.data.status);
      } else if (activetab === OldGlobals.AllPROPOSALS.UNSOLICITED && (roleID !== OldGlobals.USER_ROLES.SNR_MGR && roleID !== OldGlobals.USER_ROLES.HOP)) {
        responseData = await fetch_All_Unsolicited_Proposals(filters, pagenumber, roleID);
        setproposalsData(responseData?.data?.content?.proposals);
        setProposalsCount(responseData?.data?.content?.pageCount || 0);
        setproposalsDatastatus(responseData.data.status);
        setFavUnfavloading(responseData.data.status);
      } else if (activetab === OldGlobals.AllPROPOSALS.SOLICITED && (roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP)) {
        responseData = await fetch_All_SM_Proposals(filters, pagenumber, roleID);
        setproposalsData(responseData?.data?.content?.briefs);
        setProposalsCount(responseData?.data?.content?.pageCount);
        setproposalsDatastatus(responseData.data.status);
        setFavUnfavloading(responseData.data.status);
      } else if (activetab === OldGlobals.AllPROPOSALS.UNSOLICITED && (roleID === OldGlobals.USER_ROLES.SNR_MGR || roleID === OldGlobals.USER_ROLES.HOP)) {
        responseData = await fetch_All_SM_Unsolicited_Proposals(filters, pagenumber, roleID);
        setproposalsData(responseData?.data?.content?.proposals);
        setProposalsCount(responseData?.data?.content?.pageCount || 0);
        setproposalsDatastatus(responseData.data.status);
        setFavUnfavloading(responseData.data.status);
      }
      else {
        setproposalsData([]);
        setProposalsCount(0);
        setproposalsDatastatus("ok");
      }
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  }

  //Functionality for the ClickOutside Dropdown
  const handleClickOutside = (event) => {
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );

    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  //Listners for Mousedown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const RenderPopup = () => {
    if (selectedItem && selectedItem.status) {
      let extraprops = {};
      if (
        selectedItem.status == "Drafts" ||
        selectedItem.status == "Approved" ||
        selectedItem.status == "Rejected"
      ) {
        extraprops.normalActionText = "Submit";
        extraprops.normalAction = () => { };
        extraprops.newRejection = false;
        extraprops.isNewAcceptanceMail = false;
      }
      return (
        <PopUp
          title="Proposal Details"
          text={"Your proposal status is : " + selectedItem.status}
          onClose={() => handlePopupClose()}
          {...extraprops}
        />
      );
    } else {
      return null;
    }
  };
  const RenderReasonPopup = () => {
    if (allRejectionReasonsData?.length === 0) {
      fetchAllProposalRejectionReasons()
        .then((response) => {
          dispatch(
            setAllRejectionReasons({
              allRejectionReasons: response.data.content,
            })
          );
        })
        .catch((error) => {
          console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        });
    }
    return (
      <PopUp
        title={reasonPopup.title}
        text={reasonPopup.promptText}
        mail_rejection={true}
        limit="1024"
        customClassName={reasonPopup.customClassName}
        onClose={closeReasonPopup}
        normalAction={(data) => {
          unsolicatedProposalStatus(data, reasonPopup.toastMessage)
        }}
        normalActionText={reasonPopup.normalActionText}
        dropdownData={allRejectionReasonsData}
        textAreaStyle={reasonPopup.textAreaStyle}
        textAreaTitle={reasonPopup.textAreaTitle}
        proposalBodyVal={reasonPopup.body}
        emailContent={reasonPopup.emailContent}
      />
    );
  };

  //Functionality for opening dropdowns the Channel, CreatedBy, Producer, Status
  const handletog = async (dropdownName) => {
    console.log("langdropdown",dropdownName,dropdownState.dropdowns[dropdownName])
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    //paginationPageChange(1);

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName]?.options.length === 0 &&
      !dropdownState.dropdowns[dropdownName]?.isDatePicker
    ) {
      await fetchOptions(dropdownName);
    }
  };

  //Functionality for the fetching options Channel, CreatedBy, Producer, Status
  const fetchOptions = async (dropdownName, tabSelected = null) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      let response;
      let data;
      let filterData;
      console.log("ddadadsadadada",dropdownName.toLowerCase(),OldGlobals.SIGNUP.GENRE.toLowerCase())
      if (dropdownName == OldGlobals.FETCH_CREATEDBY) {
        response = await fetchFilterByCreatedBy(roleID, clusterId);
        filterData = response.data.content;
      } else if (dropdownName == OldGlobals.FETCH_PROPOSALSTATUS) {
        if (activeTab === OldGlobals.AllPROPOSALS.SOLICITED) {
          response = await fetchFilterProposalStatus();
          filterData = response.data.content;
        } else {
          response = await fetchFilterProposalStatusUnsolicited(roleID);
          filterData = response.data.content;
        }
      } else if (dropdownName == OldGlobals.FETCH_CHANNEL) {
        response = await fetchChannelbyClusters(OldGlobals.FILTER_OPTIONS_NAME[dropdownName], clusterId);
        data = response.data.content;
        filterData = data;
      }
      else if (dropdownName == OldGlobals.FETCH_PRODUCER) {
        response = await fetchFilterByProducerByType(clusterId, tabSelected);
        filterData = response.data.content;
      }else if(dropdownName.toLowerCase() == OldGlobals.SIGNUP.GENRE.toLowerCase()){
         response = await fetchGenresAllproposals();
         filterData = response.data.genreInfo;
      }
       else {
        response = await fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME[dropdownName]);
        data = response.data.content;
        filterData = data[OldGlobals.FILTER_OPTIONS_NAME[dropdownName]];
      }
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  //Functionality for the SelectAll
  const handleSelectAll = (dropdownName, selectAll, options) => {
    setproposalsDatastatus(null);
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataSting : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  //Functionality for the Select
  const handleSelect = (dropdownName, value, singleSelect = false) => {
    setproposalsDatastatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;

      const idStr = String(value.id);
      const nameStr = String(value.name);

      let newSelected = [];
      let newSelectedText = [];
      if (singleSelect) {
        // Replace existing with just the selected value
        const isAlreadySelected = dropdown.selected.includes(idStr);
        newSelected = isAlreadySelected ? [] : [idStr];
        newSelectedText = isAlreadySelected ? [] : [nameStr];
      } else {
        const isSelected = dropdown.selected.includes(String(value.id));
        const inSelectedText = dropdown.selectedText.includes(String(value.name));

        newSelected = isSelected
          ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
          : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

        newSelectedText = inSelectedText
          ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
          : [
            ...dropdown.selectedText.filter((item) => item !== String(value.name)),
            String(value.name),
          ];
      }

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  //Functionality for the ClearAll
  const handleClearAll = () => {
    if (enableClearAll) {
      setCurrentPage(1);
      setEnableClearAll(false);
      setproposalsDatastatus(null);
      setSearchQuery(null);
      setSearchProducerQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      setIsClearAllTriggered(true);
    }

  };

  //Functionality for the DateChange
  const handleDateChange = (dropdownName, date) => {
    setproposalsDatastatus(null);
    if (date instanceof Date && !isNaN(date)) {
      const month = date.getMonth() + 1; // Months are 0-based
      const year = date.getFullYear();

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const MonthName = monthNames[month - 1];

      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            selected: month + "-" + year,
            selectedMonthYear: month + "," + year,
            selectedText: MonthName + "-" + year,
          },
        },
      }));
    }
  };

  //Functionality for the Search
  const handleSearch = (term) => {
    console.log("handlesearch",term);
    setSearchQuery(term);
    setSearchTrigger(Date.now());
    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setproposalsDatastatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  //Functionality for the Sorting
  const handleSorting = (sorting) => {
    setDatasorting(sorting);
  };

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  const favToggleUpdateData = (page) => {
    setproposalsDatastatus(null);
    setFavUnfavloading(null);
    setproposalsDatastatus(null);

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
          }
          : {}),

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),

    search: searchQuery ? searchQuery : "",
    filter: dataSorting,
    clusterId: clusterId,
    isFavourite: favToggleState,
  };
  fetchAllProposals(data, page, activeTab);
  paginationPageChange(page);
}

const getValidPageAfterToggle = (isFavourite, size, totalCount, currentPage, pageSize = 20) => {
  const newTotalCount = isFavourite ? totalCount + 1 : totalCount - 1;
  const maxPage = Math.max(1, Math.ceil(newTotalCount / pageSize));

  if (!isFavourite && size === 1) {
    return maxPage; // go to last valid page (in your example, 1)
  }
  return Math.min(currentPage, maxPage);
};


  const updateSolicitedUnsolicitedFavourite = async (e, item, size) => {
    e.stopPropagation();
    let isFavourite = !(item.isFavourite);
    let totalcount = propsalsCount;
    let proposalDetailId = item.proposalDetailId;
    let roleId = CryptoUtils.getFromLocalStorage("roleId").toString();
    try {
      let response = await updateFavourite(isFavourite, proposalDetailId, roleId);
      const newPage = getValidPageAfterToggle(isFavourite, size, totalcount, currentPage);
      if(favToggleState){
      favToggleUpdateData(newPage);
      }
    } catch (error) {
      console.error("Error updating favourite:", error);
    }
  }

  const favFilterTableData = (newState) => {
    favState(newState);
  }

//language change logic
  useEffect(() => {
     if (isIntialRenderLanguage.current) {
      isIntialRenderLanguage.current = false;
      return; // Skip on first render
    }
     setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [], selected: [], selectedText: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });

    const data = {
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          channel: dropdownState.dropdowns.CHANNEL.selected,
          createdBy: dropdownState.dropdowns.CREATEDBY.selected,
          producerId: dropdownState.dropdowns.PRODUCER.selected.length ? dropdownState.dropdowns.PRODUCER.selected[0] : "string",
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            producer: dropdownState.dropdowns.PRODUCER.selected,
            channel: dropdownState.dropdowns.CHANNEL.selected,
          }
          : {}),

      [activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "closingDate" : "applicationDate"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      ...(activeTab === OldGlobals.AllPROPOSALS.SOLICITED
        ? {
          status: dropdownState.dropdowns.STATUS.selected,
        }
        : activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED
          ? {
            proposalStatus: dropdownState.dropdowns.STATUS.selected,
          }
          : {}),

      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
      clusterId: clusterId,
    };
    paginationPageChange(1);
    fetchAllProposals(data, 1, activeTab);
    fetchOptions((OldGlobals.FILTER.PRODUCER).toUpperCase(), activeTab);

  }, [languages]);

  return (
    <>
      <div className="All_Proposals">
        <div className="dashboard-top">
          <div className="dashboard-heading">{Globals.AllPROPOSALS.AllPROPOSALS_TEXT}</div>
          {roleID != Globals.USER_ROLES.SNR_MGR && roleID != Globals.USER_ROLES.HOP ? <Button action={() => {
            navigate(Globals.NAVPATH.CREATE_NEW_BRIEF, { state: { activeHeader: "dashboard" } });
          }} title={Globals.PRODUCER.NEWBRIEF} additionalStyle={"new-proposal"} id={"Create_New_Brief"} /> : ""}
        </div>
        <div className="all-proposals-content-box">
          <div className="all-proposal-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`proposal-overview-tab ${activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? "active" : ""
                  }`}
                onClick={() => handleTabClick(OldGlobals.AllPROPOSALS.SOLICITED)}
              >
                {Globals.AllPROPOSALS.SOLICITED}
              </div>
              <div
                className={`proposal-overview-tab ${activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED ? "active" : ""
                  }`}
                onClick={() => handleTabClick(OldGlobals.AllPROPOSALS.UNSOLICITED)}
              >
                {Globals.AllPROPOSALS.UNSOLICITED}
              </div>
            </div>
            <div className="all-proposal-top-seperater"></div>
          </div>

          <div className={`filters filters-${languages}`}>
            <div className={`results results-${languages}`}>
              {propsalsCount}{" "}
              {activeTab === OldGlobals.AllPROPOSALS.SOLICITED
                ? Globals.AllPROPOSALS.RESULTS
                : Globals.AllPROPOSALS.PROPOSALS}
            </div>
            <div className="row_spearator"></div>
            <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

            {activeTab === OldGlobals.AllPROPOSALS.SOLICITED && (
              <CheckboxDropDown
                isOpen={activeDropdown === "CHANNEL"}
                options={dropdownState.dropdowns.CHANNEL.options}
                onToggle={() => handletog("CHANNEL")}
                onSelectAll={(selectAll, options) => handleSelectAll("CHANNEL", selectAll, options)}
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("CHANNEL", value);
                }}
                selectedValues={dropdownState.dropdowns.CHANNEL.selected}
                title={Globals.FILTER.CHANNEL}
                dropdownRef={(el) => (dropdownRefs.current["Channel"] = el)}
                selectedItems={dropdownState.dropdowns.CHANNEL.selectedText}
              />
            )}

             {activeTab === OldGlobals.AllPROPOSALS.SOLICITED && (
              <CheckboxDropDown
                isOpen={activeDropdown === "GENRE"}
                options={dropdownState.dropdowns.GENRE.options}
                onToggle={() => handletog("GENRE")}
                onSelectAll={(selectAll, options) => handleSelectAll("GENRE", selectAll, options)}
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("GENRE", value);
                }}
                selectedValues={dropdownState.dropdowns.GENRE.selected}
                title={Globals.FILTER.GENRE}
                dropdownRef={(el) => (dropdownRefs.current["Genre"] = el)}
                selectedItems={dropdownState.dropdowns.GENRE.selectedText}
              />   
            )}

            {activeTab === OldGlobals.AllPROPOSALS.SOLICITED && (
              <CheckboxDropDown
                isOpen={activeDropdown === "CREATEDBY"}
                options={dropdownState.dropdowns.CREATEDBY.options}
                onToggle={() => handletog("CREATEDBY")}
                onSelectAll={(selectAll, options) =>
                  handleSelectAll("CREATEDBY", selectAll, options)
                }
                onSelect={(value) => handleSelect("CREATEDBY", value)}
                title={Globals.FILTER.CREATEDBY}
                isDatePicker={false}
                isCreatedBy={true}
                selectedValues={dropdownState.dropdowns.CREATEDBY.selected}
                dropdownRef={(el) => (dropdownRefs.current["CreatedBy"] = el)}
                selectedItems={dropdownState.dropdowns.CREATEDBY.selectedText}
              />
            )}

            {activeTab === OldGlobals.AllPROPOSALS.SOLICITED && (
              <CheckboxDropDown
                isOpen={activeDropdown === "PRODUCER"}
                options={dropdownState.dropdowns.PRODUCER.options}
                onToggle={() => handletog("PRODUCER")}
                onSelectAll={(selectAll, options) => handleSelectAll("PRODUCER", selectAll, options)}
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("PRODUCER", value, true);
                }}
                selectedValues={dropdownState.dropdowns.PRODUCER.selected}
                title={Globals.FILTER.PRODUCER}
                dropdownRef={(el) => (dropdownRefs.current["Producer"] = el)}
                selectedItems={dropdownState.dropdowns.PRODUCER.selectedText}
                singleSelect={true}
                search={true}
              />
            )}

            {activeTab === OldGlobals.AllPROPOSALS.UNSOLICITED && (
              <>
                <CheckboxDropDown
                  isOpen={activeDropdown === "CHANNEL"}
                  options={dropdownState.dropdowns.CHANNEL.options}
                  onToggle={() => handletog("CHANNEL")}
                  onSelectAll={(selectAll, options) => handleSelectAll("CHANNEL", selectAll, options)}
                  isDatePicker={false}
                  onSelect={(value) => {
                    handleSelect("CHANNEL", value);
                  }}
                  selectedValues={dropdownState.dropdowns.CHANNEL.selected}
                  title={Globals.FILTER.CHANNEL}
                  dropdownRef={(el) => (dropdownRefs.current["Channel"] = el)}
                  selectedItems={dropdownState.dropdowns.CHANNEL.selectedText}
                />
              
              <CheckboxDropDown
                isOpen={activeDropdown === "GENRE"}
                options={dropdownState.dropdowns.GENRE.options}
                onToggle={() => handletog("GENRE")}
                onSelectAll={(selectAll, options) => handleSelectAll("GENRE", selectAll, options)}
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("GENRE", value);
                }}
                selectedValues={dropdownState.dropdowns.GENRE.selected}
                title={Globals.FILTER.GENRE}
                dropdownRef={(el) => (dropdownRefs.current["Genre"] = el)}
                selectedItems={dropdownState.dropdowns.GENRE.selectedText}
              />   
                <CheckboxDropDown
                  isOpen={activeDropdown === "PRODUCER"}
                  options={dropdownState.dropdowns.PRODUCER.options}
                  onToggle={() => handletog("PRODUCER")}
                  onSelectAll={(selectAll, options) =>
                    handleSelectAll("PRODUCER", selectAll, options)
                  }
                  onSelect={(value) => handleSelect("PRODUCER", value)}
                  title={Globals.FILTER.PRODUCER}
                  isDatePicker={false}
                  isCreatedBy={true}
                  selectedValues={dropdownState.dropdowns.PRODUCER.selected}
                  dropdownRef={(el) => (dropdownRefs.current["Producer"] = el)}
                  selectedItems={dropdownState.dropdowns.PRODUCER.selectedText}
                  search={true}
                />
              </>
            )}

            <CheckboxDropDown
              isOpen={activeDropdown === "DATE"}
              options={dropdownState.dropdowns.DATE.options}
              onToggle={() => handletog("DATE")}
              onSelectAll={(selectAll) => handleSelectAll("DATE", selectAll)}
              onSelect={(value) => handleSelect("DATE", value)}
              title={
                activeTab === OldGlobals.AllPROPOSALS.SOLICITED
                  ? roleID === Globals.USER_ROLES.SNR_MGR
                    ? Globals.FILTER.CLOSINGDATE
                    : Globals.FILTER.CLOSINGDATE
                  : Globals.FILTER.APPLICATIONDATE
              }
              isDatePicker={true}
              selectedValues={dropdownState.dropdowns.DATE.selected}
              selectedMonthYear={dropdownState.dropdowns.DATE.selectedMonthYear}
              selectedMonthYearText={dropdownState.dropdowns.DATE.selectedText}
              dropdownRef={(el) => (dropdownRefs.current["Date"] = el)}
              onDateChange={(date) => handleDateChange("DATE", date)}
              zIndex={2}
              isClosingDate={activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? true : false}

            />
            <CheckboxDropDown
              isOpen={activeDropdown === "STATUS"}
              options={dropdownState.dropdowns.STATUS.options}
              onToggle={() => handletog("STATUS")}
              onSelectAll={(selectAll, options) => handleSelectAll("STATUS", selectAll, options)}
              onSelect={(value) => {
                handleSelect("STATUS", value);
              }}
              isDatePicker={false}
              selectedValues={dropdownState.dropdowns.STATUS.selected}
              title={Globals.FILTER.STATUS}
              dropdownRef={(el) => (dropdownRefs.current["Status"] = el)}
              selectedItems={dropdownState.dropdowns.STATUS.selectedText}
            />

            <div
              className={enableClearAll ? "clear clearAllEnable" : "clear"}
              onClick={() => handleClearAll()}
            >
              {Globals.PRODUCER.CLEARALL}
            </div>

            <div className="search">
              <Search
                onSearch={handleSearch}
                searchedFor={searchQuery}
                placeholder={activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? Globals.INTERNAL.BRIEFNO : Globals.INTERNAL.PROPOSALTITLENO}
              />
            </div>
          </div>
          {activeTab === Globals.AllPROPOSALS.UNSOLICITED ? (
            <div className="favourites-container">
              <div id="fav-star" className="fav-star">
                  <img src={OldGlobals.IMG.STAR_SOLID} alt="favourites" />
              </div>
              <div className="favourites-title">{Globals.FAVOURITES}</div>
              <ToggleSwitchButton
              isToggled={favToggleState} setIsToggled={favState}
              taggleFun={favFilterTableData}
              />
            </div>
          ) : (<div className="favourites-container">
              <div id="fav-star" className="fav-star">
                  <img src={OldGlobals.IMG.STAR_SOLID} alt="favourites" />
              </div>
              <div className="favourites-title">{Globals.FAVOURITES}</div>
              <ToggleSwitchButton
              isToggled={favToggleState} setIsToggled={favState}
              taggleFun={favFilterTableData}
              />
            </div>)}
          <div className="Table_data">
            {proposalsData && proposalsData.length > 0 ? (
              <NestedTable
                data={proposalsData}
                onSort={handleSorting}
                onRowClick={handleRowClick}
                popupShow={{openPopup,openReasonPopup,toggleSmEvaluation, toggleHOPEvaluation}}
                refreshDashboard={refreshDashboard}
                renderToast={renderToast}
                isNested={activeTab === OldGlobals.AllPROPOSALS.SOLICITED ? true : false}
                updateSolicitedUnsolicitedFavourite = {updateSolicitedUnsolicitedFavourite}
                currentPage={currentPage}
                sortKey ={dataSorting}
              />
            ) : proposalsDatastatus && proposalsDatastatus.length > 0 ? (
              <div className="no-data">
                <NoResultsComponent
                  data={{
                    message:
                      dropdownselected || (searchQuery && searchQuery.length > 0)
                        ? Globals.NO_RESULTS_MESSAGE
                        : Globals.NO_DATA_WITHOUTFILTER,
                    img:
                      dropdownselected || (searchQuery && searchQuery.length > 0)
                        ? OldGlobals.NO_RESULTS_IMG
                        : OldGlobals.NO_DATA_FOUND_IMG,
                    submessage:
                      dropdownselected || (searchQuery && searchQuery.length > 0)
                        ? Globals.NO_RESULTS_SUBMESSAGE
                        : "",
                  }}
                />
              </div>
            ) : (
              <Loader height={50} width={50} component={"Allproposals"} />
            )}
          </div>
          <div className="pagination-container">
            {proposalsData && proposalsData.length > 0 ? (
              <Pagination
                totalPages={Math.ceil(propsalsCount / Globals.MAX_COUNT.TABLE_DATA_COUNT)}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
   {favToggleState && favUnfavloading === null && (
<Loader height={50} width={50} component={"Allproposals"} />
   )}
      <RenderPopup />
      {Popup.open && <PopUp
        title={Popup.title}
        text={Popup.promptText}
        {...(checkReAssign ?
          { comments: true } : { email: (!Popup.newRejection && !Popup.isNewAcceptanceMail) })}
        limit="1024"
        customClassName={Popup.customClassName}
        onClose={closePopup}
        normalAction={(data) => {
          checkReAssign ? reassignProposal(data, Popup.toastMessage) : unsolicatedProposalStatus(data, Popup.toastMessage)

        }}
        normalActionText={Popup.normalActionText}
        textAreaStyle={Popup.textAreaStyle}
        textAreaTitle={Popup.textAreaTitle}
        proposalBodyVal={Popup.body}
        newRejection={Popup.newRejection}
        isNewAcceptanceMail={Popup.isNewAcceptanceMail}
        emailContent={Popup.emailContent}
      />}
      {
        reasonPopup.open && <RenderReasonPopup />
      }
      {smEvaluation.open && <PopUp
        title={Globals.SM_EVALUATION_POPUP.TITLE}
        text={Globals.SM_EVALUATION_POPUP.MESSAGE}
        normalAction={() =>
          unsolicatedProposalStatus(smEvaluation?.body, smEvaluation.toastMessage)
        }
        normalActionText={Globals.ASSIGN_PROPOSLS}
        onClose={() => setSmEvaluation({ open: false })}
      />}
        {hopEvaluation.open && <PopUp
          title={Globals.HOP_EVALUATION_POPUP.TITLE||OldGlobals.HOP_EVALUATION_POPUP.TITLE}
          text={Globals.HOP_EVALUATION_POPUP.MESSAGE || OldGlobals.HOP_EVALUATION_POPUP.MESSAGE}
          normalAction={() =>
            unsolicatedProposalStatus(hopEvaluation?.body,hopEvaluation.toastMessage)
          }
          normalActionText={Globals.ASSIGN_PROPOSLS}
          onClose={() => setHOPEvaluation({open:false})}
        />}
      {toast.open && <Toast status={toast.status} onClose={() => { setToast({ open: false, status: '', title: '' }); }} title={toast.title} />}
      {successToast.status && <Toast status="success" onClose={() => { setSuccessToast(false); }} title={successToast.title} />}
    </>
  );
};

export default AllProposals;
